import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { CaseDocumentAdmin } from "pwapi";

import {
  fetchDocument,
  setDocument,
} from "shared/actions/admin/adminDocumentsActions";
import { CaseAdminDetail } from "shared/reducers/admin/adminCaseReducer";

import DjangoLink from "components/DjangoLink";
import Spinner from "components/Spinner";
import ApplicationState from "store/ApplicationState";

import DocumentWarningDialog from "./DocumentWarningDialog";
import EditDocumentsForm from "./EditDocumentsForm";
import UploadDocumentsForm from "./UploadDocumentsForm";
import AdminPanel from "../adminPanel/AdminPanel";
import HalfScreenPanel from "../editPanels/halfScreenEditPanel/HalfScreenPanel";

type DocumentsPanelProps = {
  returnUrl: string;
  adminCase?: CaseAdminDetail;
  documentId?: number;
  isUploading?: boolean;
};

const DocumentsPanel = ({
  returnUrl,
  adminCase,
  documentId,
  isUploading,
}: DocumentsPanelProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { document, isLoading } = useSelector(
    ({ admin }: ApplicationState) => admin.document
  );

  const [docToDelete, setDocToDelete] = useState<
    CaseDocumentAdmin | undefined
  >();

  useEffect(() => {
    if (documentId) {
      dispatch(fetchDocument(documentId));
    }
    return () => {
      navigate(returnUrl, { replace: true });
      dispatch(setDocument(null));
    };
  }, []);

  const handleOnClose = () => {
    navigate(returnUrl, { replace: true });
    dispatch(setDocument(null));
  };

  return (
    <>
      {docToDelete?.id && (
        <DocumentWarningDialog
          document={docToDelete}
          closePanel={handleOnClose}
          onClose={() => {
            setDocToDelete(undefined);
          }}
        />
      )}
      <HalfScreenPanel onClose={handleOnClose}>
        <div className="HalfScreen__container">
          {isUploading ? (
            <AdminPanel
              title={{
                main: "Upload Document",
              }}
            >
              <UploadDocumentsForm
                adminCase={adminCase}
                onClose={handleOnClose}
              />
            </AdminPanel>
          ) : document && !isLoading ? (
            <AdminPanel
              title={{
                prefix: `Document #${document.id}`,
                main: document.name,
              }}
              djangoLink={
                <DjangoLink
                  route={`pathology/casedocument/${document.id}/change/`}
                  title="Django Document Access"
                />
              }
              canOverflow
            >
              <EditDocumentsForm
                document={document}
                adminCase={adminCase}
                onClose={handleOnClose}
                onDelete={setDocToDelete}
              />
            </AdminPanel>
          ) : (
            <div className="Panel__spinner">
              <Spinner />
            </div>
          )}
        </div>
      </HalfScreenPanel>
    </>
  );
};

export default DocumentsPanel;
